module.exports = __webpack_public_path__ + "img/專案總監-Renee_工作區域 1.3dab67a0.jpg";